import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../user.service';

@Injectable({ providedIn: "root" })
export class AuthInterceptor implements HttpInterceptor {
  constructor(private userService: UserService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let url = request.url;
    let token: string = this.userService.getToken()!;
    let authReq = null;
    if (url.indexOf("uat-api.moneytor.care") != -1) {
      token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7InVzZXJJZCI6MiwidXNlclByb2ZpbGVJZCI6Mn0sImlhdCI6MTY5ODY0ODk4MSwiYXVkIjoiYWxsIiwiaXNzIjoibW9uZXl0b3IifQ.iZG-0AGW2Kf6OfkajDbbnxsq23F5mvd3PCvk3E-gZoY"
      authReq = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    } else {
      authReq = request.clone({
        setHeaders: {
          Authorization: `JWT ${token}`
        }
      });
    }


    // TODO: add this content type if error 'Content-Type': 'application/json'

    // Append callingType header from URL query params when present
    const urlParams = new URLSearchParams(window.location.search);
    let callingType = urlParams.get('callingType');
    if (!callingType) {
      try {
        callingType = localStorage.getItem('callingType');
      } catch (_e) {
        callingType = null;
      }
    }
    // Recover callingType from mangled path: /timeline/123%3F...callingType%3Dcube
    if (!callingType) {
      try {
        const path = decodeURIComponent(window.location.pathname || '');
        const m = path.match(/callingType[=:](\w+)/i) || path.match(/callingType%3D(\w+)/i);
        if (m?.[1]) {
          callingType = m[1];
        }
      } catch (_e) {}
    }
    if (callingType) {
      authReq = authReq.clone({
        setHeaders: { callingType }
      });
    }

    // modifing header for incoming  call.
    let featureList: any = null;
    try {
      featureList = JSON.parse(localStorage.getItem('featureList')!);
    } catch (_e) {
      featureList = null;
    }
    let incomingCall = localStorage.getItem('incomingCall');
    // STEP 9 (ivrAgentConnect): URL ?callingType=ivr → treat like inbound so due APIs allow access.
    if (!incomingCall && (callingType === 'cube' || callingType === 'ozonetel' || callingType === 'centro' || callingType === 'ivr')) {
      incomingCall = 'true';
    }

    if (incomingCall && (featureList?.['useIncomingCallFlow'] || callingType === 'cube' || callingType === 'ozonetel' || callingType === 'centro' || callingType === 'ivr')) {
      const incomingReq = authReq.clone({
        setHeaders: { incomingCall: 'true' }
      });
      return next.handle(incomingReq);
    }
    return next.handle(authReq);
  }
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private user: UserService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((response: any) => {
        if (response instanceof HttpErrorResponse && response.status === 401) {
          console.error('on error', response);
        }
        return this.user.getCheckError(response);
      })
    );
  }
}
